import React from 'react';
type InputProps = {
  label: string;
  type: string;
  id: string;
  name: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
  className?: string;
};
const Input = ({
  label,
  type,
  id,
  name,
  placeholder,
  value,
  onChange,
  required = false,
  error,
  className = ''
}: InputProps) => {
  return <div className={`mb-4 ${className}`} data-id="element-408">
      <label htmlFor={id} className="block mb-2 font-medium text-dark" data-id="element-409">
        {label} {required && <span className="text-red-500" data-id="element-410">*</span>}
      </label>
      <input type={type} id={id} name={name} placeholder={placeholder} value={value} onChange={onChange} required={required} className={`w-full px-4 py-2.5 rounded-custom border ${error ? 'border-red-500' : 'border-border'} focus:outline-none focus:ring-2 focus:ring-primary/50`} data-id="element-411" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-412">{error}</p>}
    </div>;
};
export default Input;